<template>
    <app-layout v-if="isPageReady" printClass="print-referral-listing">
        <div>
            <div>
                <div>
                    <div class="referral-tracking__main-tabs">
                        <button type="button" :class="mainTabClass('provider')" @click="goToProviderReferrals">
                            {{ $t('pages.referrals.index.referrals_made.provider_received_referral') }}
                            <span v-if="providerPendingActionCount" class="referral-tracking__count-information">
                                {{ providerPendingActionCount }}
                            </span>
                        </button>
                        <button type="button" :class="mainTabClass('patient')" @click="goToPatientReferrals">
                            {{ $t('pages.referrals.index.referrals_made.provider_received_request') }}
                            <span v-if="patientPendingActionCount" class="referral-tracking__count-information">
                                {{ patientPendingActionCount }}
                            </span>
                        </button>
                    </div>
                </div>

                <div v-if="activeMainTab === 'provider'">
                    <provider-referrals></provider-referrals>
                </div>

                <div v-if="activeMainTab === 'patient'" class="referral-tracking__patient-requests-section">
                    <referrals-made></referrals-made>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithElementsMixin from 'mixins/PageWithElementsMixin'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import AppLayout from 'components/layouts/AppLayout'
    import ReferralService from 'services/ReferralService'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    import ProviderReferrals from 'components/page-elements/referrals/ProviderReferrals'
    import ReferralsMade from 'components/page-elements/referrals/ReferralsMade'
    import Store from '~/store'
    export default {
        mixins: [PageWithTitleMixin, PageWithElementsMixin, PageWithDataMixin],
        components: {
            AppLayout,
            ProviderReferrals,
            ReferralsMade,
        },
        data() {
            return {
                activeReferralTab: 'made',
                activePatientTab: 'requests',
                showPatientDetailsModal: false,
                activeReferral: {},
                PracticeTypeEnum: PracticeTypeEnum,
                practiceData: {},
                dropdownStates: {},
                actionStates: {},
            }
        },
        provide() {
            return {
                isReferralPool: false,
            }
        },
        computed: {
            activeMainTab() {
                return this.$route.name?.startsWith('referrals-patient') ? 'patient' : 'provider'
            },
            providerPendingActionCount() {
                if (this.$auth.isUserTemporaryPhysician()) {
                    return 1
                }

                return Store.getters['auth/getProviderPendingReferralActionCount']
            },
            patientPendingActionCount() {
                return Store.getters['auth/getPatientPendingReferralActionCount']
            },
        },
        methods: {
            mainTabClass(tab) {
                return ['referral-tracking__main-tab', { active: this.activeMainTab === tab }]
            },
            toggleReferralDropdown(index) {
                this.dropdownStates[index] = !this.dropdownStates[index]
            },
            toggleDropdown(index) {
                Object.keys(this.dropdownStates).forEach((key) => {
                    if (key != index) {
                        this.$set(this.dropdownStates, key, false)
                    }
                })

                this.$set(this.dropdownStates, index, !this.dropdownStates[index])
            },

            closeDropdown(index) {
                this.$set(this.dropdownStates, index, false)
            },

            getDropdownPosition() {
                return {
                    position: 'absolute',
                    top: '80%',
                    right: '8px',
                    marginTop: '4px',
                    height: 'auto',
                    zIndex: 1000,
                }
            },

            getCreatedDate(referral) {
                if (!referral || !referral.createdAt) return 'N/A'
                return new Date(referral.createdAt).toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                })
            },

            printPage() {
                window.print()
            },
            getUserFullName(patient) {
                return patient ? `${patient.firstName} ${patient.lastName}` : 'N/A'
            },
            getPatientDateOfBirth(patient) {
                return patient ? '01/01/1990' : 'N/A'
            },
            changeTab(event) {
                this.$router.push({ name: `referrals.${this.$route.params.type}.${event}` })
            },
            goToProviderReferrals() {
                if (this.$route.name?.startsWith('referrals.')) return
                this.$router.push({
                    name: 'referrals.received',
                })
            },

            goToPatientReferrals() {
                this.$router.push({
                    name: 'referrals-patient.received',
                })
            },
        },
        created() {
            ReferralService.fetchPendingReferralActions()
        },
    }
</script>
